export const DEFAULT_TEAM_NAMES = ['Red', 'Green', 'Yellow', 'Blue'];
